// File: VPNSection.jsx
import React, { useState } from "react";
import WireGuardInfo from "../WireGuard_Info.tsx";
import V2RayTunInfo from "./V2RayTun_Info.jsx";

function VPNSection({ user }) {
  const [showV2, setShowV2] = useState(false);

  return (
    <div className="vpn-section">
      <header className="vpn-section__intro">
        <div>
          <span className="vpn-section__eyebrow">Безопасное подключение</span>
          <h2 className="vpn-section__title">Ваш VPN</h2>
        </div>
        <p className="vpn-section__subtitle">Выберите удобный способ подключения</p>
      </header>
      <div className="vpn-stack">
        <section className="vpn-stack__section vpn-stack__section--wg">
          <header className="vpn-stack__section-header">
            <div className="vpn-stack__section-badge vpn-stack__section-badge--wg">
              <img src="/wg2.png" alt="WireGuard" className="vpn-stack__section-badge-image" />
            </div>
            <div>
              <h3>WireGuard</h3>
              <p>Быстрое подключение</p>
            </div>
          </header>
          <div className="vpn-stack__section-body">
            <WireGuardInfo user={user} />
          </div>
        </section>

        <details
          className="vpn-stack__section vpn-stack__section--v2 vpn-stack__disclosure"
          onToggle={(event) => {
            if (event.currentTarget.open) {
              setShowV2(true);
            }
          }}
        >
          <summary className="vpn-stack__section-header">
            <div className="vpn-stack__section-badge vpn-stack__section-badge--v2">
              <img src="/v2.png" alt="V2" className="vpn-stack__section-badge-image" />
            </div>
            <div>
              <h3>V2 Reality</h3>
              <p>Для сложных сетей</p>
            </div>
          </summary>
          <div className="vpn-stack__section-body">
            {showV2 && <V2RayTunInfo user={user} />}
          </div>
        </details>
      </div>
    </div>
  );
}

export default VPNSection;
